import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { PurchaseRoutingModule } from './purchase-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card'
import { MatMenuModule } from '@angular/material/menu';
import { PurchaseItemCardComponent } from 'src/app/components/purchase-item-card/purchase-item-card.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { OrderCatogoryCardModule } from 'src/app/components/modules/order-catogory-card/order-catogory-card.module';
import { TranslateModule } from '@ngx-translate/core';
import { ImageCropperModule } from 'src/app/dialog/image-cropper/image-cropper.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ImageModule } from 'src/app/components/image/image.module';
import { TicketCardModule } from 'src/app/components/ticket-card/ticket-card.module';
import { PurchaseHomeComponent } from './components/purchase-home/purchase-home.component';
import { ReceiptDialogModule } from 'src/app/dialog/receipt-dialog/receipt-dialog.module';
import { OrderFormModule } from 'src/app/components/routes/order-form/order-form.module';
import { OrderCategoryGroupModule } from 'src/app/components/order-category-group/order-category-group.module';


@NgModule({
  declarations: [
    PurchaseItemCardComponent,
    PurchaseHomeComponent
  ],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    OrderCatogoryCardModule,
    FormsModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatCardModule,
    ImageModule,
    MatToolbarModule,
    ImageCropperModule,
    TicketCardModule,
    MatChipsModule,
    MatSelectModule,
    MatTableModule,
    MatRippleModule,
    MatDialogModule,
    MatDatepickerModule,
    MatDividerModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatStepperModule,
    MatProgressSpinnerModule,
    TranslateModule,
    ReceiptDialogModule,
    PurchaseRoutingModule,
    OrderFormModule,
    OrderCategoryGroupModule
  ],
  providers: [
    DatePipe
  ]
})
export class PurchaseModule { }
